/**
 * Admin Settings home: title "管理者設定", green-bordered area,
 * left sidebar (NavbarSettings) and right content area for each settings section.
 */
import React, { useState } from 'react';
import NavbarSettings, { SettingsNavItem } from './navbarSettings';
import MailAddressSettings from './mailAddressSettings/mailAddressSettings';
import ApplicationManagement from './applicationManagement/applicationManagement';
import MailTemplatesSettings from './mailtemplates/mailTemplates';
import PostalCodeDataUpload from './postalCodeDataUpload/PostalCodeDataUpload';
import AdminActivityLog from './activityLog/AdminActivityLog';
import './settingsHome.css';

export interface SettingsHomeProps {
  /** Optional custom content per section; if not provided, shows placeholder */
  renderContent?: (activeItem: SettingsNavItem) => React.ReactNode;
}

const SettingsHome: React.FC<SettingsHomeProps> = ({ renderContent }) => {
  const [activeItem, setActiveItem] = useState<SettingsNavItem>('email-template');

  const content = renderContent
    ? renderContent(activeItem)
    : activeItem === 'email-address'
      ? <MailAddressSettings />
      : activeItem === 'postal-code-data'
        ? <PostalCodeDataUpload />
      : activeItem === 'application'
        ? <ApplicationManagement />
      : activeItem === 'email-template'
        ? <MailTemplatesSettings />
      : activeItem === 'activity-log'
        ? <AdminActivityLog />
      : null;

  return (
    <div className="settings-home">
      <h1 className="settings-home__title">管理者設定</h1>
      <div className="settings-home__container">
        <div className="settings-home__nav-wrap">
          <NavbarSettings
            activeItem={activeItem}
            onItemChange={setActiveItem}
          />
        </div>
        <div className="settings-home__main">
          {content}
        </div>
      </div>
    </div>
  );
};

export default SettingsHome;
